module.exports = __webpack_public_path__ + "bin/ec2095deeb0d97656491af024566a42e.jpg";